var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.authenticated)?[_c('Navbar',{attrs:{"id":"nav"}}),_c('div',{staticClass:"mt-2",attrs:{"id":"content"}},[_c('router-view')],1)]:_c('LoginModal')],2)}
var staticRenderFns = []

export { render, staticRenderFns }